import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { Field, NumericInput, TextInput, TextOutput } from 'Components/Core';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';

const DryMassSection = () => (
  <ListFieldSection heading="Initial Material Dry Mass">
    <WorksheetBalanceFieldSet label="Balance" name="Equipment.InitialBalance" />
    <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Equipment.InitialOven" />
    <Field input={<TextInput />} name="Masses.InitialTareID" label="Tare ID" maxLength={20} />
    <Field input={<NumericInput />} label="Tare Mass" name="Masses.InitialTareMass" />
    <Field input={<NumericInput />} label="Tare and Dry Mass" name="Masses.InitialTareAndDryMass" />
    <Field input={<TextOutput />} label="Dry Mass" name="Masses.InitialDryMass" />
  </ListFieldSection>
);

export { DryMassSection };
